"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_DYNAMIC_CONTEXTS = void 0;
const entities_1 = require("../entities");
const BASE_DYNAMIC_CONTEXTS = [
    entities_1.componentAttributes,
];
exports.BASE_DYNAMIC_CONTEXTS = BASE_DYNAMIC_CONTEXTS;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL3V0aWxzL2R5bmFtaWNDb250ZXh0L2NvbXBvbmVudHMvY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLDBDQUFrRDtBQUVsRCxNQUFNLHFCQUFxQixHQUF3RDtJQUMvRSw4QkFBbUI7Q0FDdEIsQ0FBQztBQUVPLHNEQUFxQiJ9


// WEBPACK FOOTER //
// ../../../../../src/utils/dynamicContext/components/constants.ts